import { SourcingEventV2Dto } from "../../../../autogen/bff-api";

export type CompetitionStage = "REQUESTS_OPEN" | "QUALIFICATION" | "TENDERING";

// Both values are derived server-side from the qualification round and the server clock —
// the single source of truth. Never re-derive stage or deadline from raw eventData fields:
// for two-stage events the tilbudsfrist lives on the invitation, not in eventData.
export const competitionStage = (event: SourcingEventV2Dto): CompetitionStage | null =>
  (event.competitionStage as CompetitionStage | undefined) ?? null;

export const effectiveBidDeadline = (event: SourcingEventV2Dto): string | null =>
  event.milestoneDates?.bidSubmissionDeadline ?? null;
